import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import CommonGrid from "../../../Repository/CommonGrid";
import { useTranslation } from "react-i18next";
import LabeledCheckbox from "../../../TemplateProperties/TPCheckbox";
import { useDispatch, useSelector } from "react-redux";
import { api, useGetPdcListQuery } from "../../../../redux/api";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { encodingConstant } from "../../../../constants/constantList";
import { treeActions } from "../../../../redux/slices/treeSlice";
import { Loader } from "../../../../utils/loader";
import { isArray } from "lodash";
import LightTooltip from "../../../../commonComponents/LightTooltip";

const DatabaseNavigatorLeft = ({
  showQuery,
  enable,
  loadButton,
  connection,
  setConnection,
  encoding,
  setEncoding,
  schema,
  setSchema,
  selectedTable,
  setSelectedTable,
  sort,
  setSort,
  alreadyConnected,
  prepend,
  setPrepend,
  selectedConnection,
  showAlert,
  setConnectionLoading,
  selectedSchema,
  modalOpen,
  fromCustomDB = false
}) => {
  const { t } = useTranslation();
  const { account, user } = useSelector((state) => state.queryParams);
  const [connectOptions, setConnectionOptions] = useState([]);
  const [gridAPI, setGridAPI] = useState();
  const [rowData, setRowData] = useState([]);
  const [schemaOptions, setSchemaOptions] = useState([]);
  const parentScreen = useContext(ParentScreenCtx);
  const [isSchemaLoaded, setIsShemaLoaded] = useState(false);
  const pdc = useSelector((state) => state.treeData[parentScreen].pdc);
  const dispatch = useDispatch();
  const connectionLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["SCHEMA_LOADING"]?.isLoading || false) // Commenting this for now
  const connectionError = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["SCHEMA_LOADING"]?.isError || false) // Commenting this for now
  const tableLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.['TABLE_LOADING']?.isLoading || false);
  const metaLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["META_LOADING"]?.isLoading || false)
  const top25Loading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["TOP25_LOADING"]?.isLoading || false)
  const sqlLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["SQL_LOADING"]?.isLoading || false)
  const compareLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.["COMPARE_LOADING"]?.isLoading || false)
  const schemaTimerRef = useRef();
  const tableTimerRef = useRef();

  const onSelectionChanged = (gridOptions) => {
    const selectedRows = gridOptions.api.getSelectedRows();
    if (selectedRows.length > 0) {
      setSelectedTable(selectedRows[0].table);
    } else {
      setSelectedTable('');
    }
    // disableAllLoading();
  };
  const gridOptions = {
    columnDefs: [
      {
        headerName: "",
        field: "table",
        editable: false,
        resizable: false,
      },
    ],
    headerHeight: 0,
    onSelectionChanged: onSelectionChanged,
    noRowsOverlay: t('ACTVTXN_NOTHING_TO_DISPLAY')
  };

  const onRowDataUpdated = (gridOptions) => {
    const node = gridOptions.api.getRowNode(0);
    if (node) {
      node.setSelected(true);
      setSelectedTable(node.data.table);
    }
  };

  const encodingOptions = Object.keys(encodingConstant).map((e, i) => {
    return (
      <MenuItem value={e} key={i}>
        {t(encodingConstant[e])}
      </MenuItem>
    );
  });

  const updateTableRowData = (tables) => {

    if (sort) tables?.sort((a, b) => {
      return a.localeCompare(b);
    })

    setRowData(
      tables?.map((e, i) => {
        return {
          id: i + 1,
          table: e,
        };
      }) || []
    );
  };

  const updateSchemaOptions = (schemas) => {
    setSchemaOptions(
      schemas
        ?.filter((e) => e)
        .map((e, i) => {
          return (
            <MenuItem value={e} key={i}>
              {e}
            </MenuItem>
          );
        })
    );
    if (!schema) setSchema(schemas?.[0] || '');
  };

  const updateConnectionsOptions = (connections) => {
    const options = [t('SELECT'), ...connections]
    setConnectionOptions(
      options.map((e, i) => {
        return (
          <MenuItem value={e} key={i}>
            {e}
          </MenuItem>
        );
      })
    );
  };

  const loadDatabaseSchemaHandler = () => {
    if (schemaTimerRef.current) clearTimeout(schemaTimerRef.current);
    if (!connection && !selectedConnection) return;
    if (alreadyConnected) {
      const schemas = Object.keys(pdc?.[connection || selectedConnection] || {});
      updateSchemaOptions(schemas);
      setIsShemaLoaded(true);
      dispatch(treeActions.setLoadingActions({ screen: parentScreen, key: "SCHEMA_LOADING", data: { isLoading: false, isError: false } }));
      return;
    }
    dispatch(treeActions.setLoadingActions({ screen: parentScreen, key: "SCHEMA_LOADING", data: { isLoading: true, isError: false } }));
    setConnectionLoading(true);
    dispatch(
      api.endpoints.connect_to_selected_db.initiate({
        account: account,
        user: user,
        direction: parentScreen === "inbound" ? "IN" : "OUT",
        pdc_name: connection || selectedConnection,
      }, { forceRefetch: true }),
    )
      .then(res => {
        if (['success', 'connected'].includes(res?.data?.message?.trim()?.toLowerCase())) {
          showAlert({ mssg: res?.data?.data?.toUpperCase() || res?.data?.message?.toUpperCase(), isOpen: true, type: 'success' })
          const schemas = Object.keys(pdc?.[connection || selectedConnection] || {});
          if (!schemas?.length && (connection || selectedConnection)) {
            dispatch(
              api.endpoints.getSchemaList.initiate(
                {
                  account,
                  direction: parentScreen === "inbound" ? "in" : "out",
                  pdc_name: connection || selectedConnection,
                },
                { forceRefetch: true }
              )
            ).then((res) => {
              if (res?.data?.current_state === "SUCCESS" && isArray(res?.data?.data)) {
                setIsShemaLoaded(true)
              } else {
                setIsShemaLoaded(false);
                const message = !isArray(res?.data?.data) ? res?.data?.data : res?.data?.message;
                showAlert({ mssg: message, isOpen: true, type: 'warning' })
              }
            });
          } else {
            updateSchemaOptions(schemas);
            setIsShemaLoaded(true);
            dispatch(treeActions.setLoadingActions({ screen: parentScreen, key: "SCHEMA_LOADING", data: { isLoading: false, isError: false } }));
          }
          // showAlert({mssg: res?.data?.message?.toUpperCase(), type: 'success', isOpen: true})
        } else {
          showAlert({ mssg: res?.data?.data?.toUpperCase() || res?.data?.message?.toUpperCase(), type: 'warning', isOpen: true })
          setIsShemaLoaded(false);
          dispatch(treeActions.setLoadingActions({ screen: parentScreen, key: "SCHEMA_LOADING", data: { isLoading: false, isError: false } }));
        }
      })
    // schemaTimerRef.current = setTimeout(() => {
    //     dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "SCHEMA_LOADING", data: {isError: true}}));
    // }, 120000)
  };

  useEffect(() => {
    if (connectionError && connectionLoading) {
      showAlert({ mssg: t('BOX_MSG_GENERAL_ERROR'), isOpen: true, type: 'warning' });
      dispatch(treeActions.setLoadingActions({ screen: parentScreen, key: "SCHEMA_LOADING", data: { isLoading: false, isError: false } }));
      setIsShemaLoaded(false);
    }
  }, [connectionError])

  const databaseTableHandler = (schema) => {
    if (tableTimerRef.current) clearTimeout(tableTimerRef.current);
    if (!schemaOptions?.length) return;
    updateTableRowData([]);
    setSelectedTable('');
    if (!schema) {
      setConnectionLoading(false);
      return;
    }
    dispatch(treeActions.setLoadingActions({ screen: parentScreen, key: "TABLE_LOADING", data: { isLoading: true, isError: false } }));
    setConnectionLoading(true);
    const tables = Object.keys(pdc?.[connection || selectedConnection]?.[schema] || {});
    if (!tables?.length && connection && schema) {
      dispatch(
        api.endpoints.get_database_table_info.initiate(
          {
            account,
            user,
            direction: parentScreen === "inbound" ? "IN" : "OUT",
            pdc_name: connection,
            schema_name: schema,
          },
          { forceRefetch: true }
        )
      )
        .then(res => {
          if (res?.data?.current_state === "SUCCESS" && isArray(res?.data?.data?.database_table_list)) {
          }
          else {
            const message = res?.data?.message;
            showAlert({ mssg: message, isOpen: true, type: 'warning' });
          }
        })
      setConnectionLoading(false);
    } else {
      updateTableRowData(tables);
      setConnectionLoading(true);
      setSelectedTable(tables[0]);
      dispatch(treeActions.setLoadingActions({ screen: parentScreen, key: "TABLE_LOADING", data: { isLoading: false, isError: false } }));
    }
    // tableTimerRef.current = setTimeout(() => {
    //     dispatch(treeActions.setLoadingActions({screen: parentScreen, key: "TABLE_LOADING", data: {isError: true}}));
    // }, 120000)
  };

  const disableAllLoading = () => {
    ["SCHEMA_LOADING", "TABLE_LOADING", "META_LOADING", "TOP25_LOADING", "SQL_LOADING", "COMPARE_LOADING"].forEach(e => {
      dispatch(treeActions.setLoadingActions({ screen: parentScreen, key: e, data: { isLoading: false, isError: false } }));
    })
  }

  useEffect(() => {
    getConnections();
    const connections = Object?.keys(pdc || {});
    const schemas = Object.keys(pdc?.[connection] || {});
    const tables = Object.keys(pdc?.[connection]?.[schema] || {});
    if (!connectOptions.length) {
      updateConnectionsOptions(connections);
    }
    // console.log(schemas, isSchemaLoaded);
    if (schemas?.length && isSchemaLoaded) {
      updateSchemaOptions(schemas);
      setIsShemaLoaded(true);
      if (!schema) setSchema(schemas?.[0] || "");
    }
    if (tables?.length && isSchemaLoaded) {
      updateTableRowData(tables);
    }
  }, [pdc, isSchemaLoaded]);

  const getConnections = () => {
    dispatch(api.endpoints.getAllPdcDetail.initiate({
        account: account,
        direction: parentScreen === "inbound" ? "in" : "out"
    }, {forceRefetch: true})).then(res => {
        if (res?.data?.current_state === 'ERROR' || !res?.data?.predefined_connections) {
            console.log(res?.data?.current_state);
        } else {
            const list = [];
            for (const [key, value] of Object.entries(res?.data?.predefined_connections)) {
                if (Object.values(value)[0]?.DATABASE_TYPE !== undefined)
                    list.push(Object.keys(value)[0]);
            }
            updateConnectionsOptions(list);
        }
    })
  }

  useEffect(() => {
    if (schema) {
      databaseTableHandler(schema);
    }
  }, [schema, sort]);

  useEffect(() => {
    if (alreadyConnected) loadDatabaseSchemaHandler()
  }, [alreadyConnected])

  useEffect(() => {
    if (fromCustomDB && modalOpen) loadDatabaseSchemaHandler()
  }, [fromCustomDB, modalOpen])

  useEffect(() => {
    if (isSchemaLoaded) {
      setSort(true);
    }
  }, [isSchemaLoaded])

  useEffect(() => {
    disableAllLoading();
    return () => {
      disableAllLoading();
    }
  }, [modalOpen])

  return (
    <Box
      sx={{
        width: "95%",
        height: "95%",
        margin: "auto",
        display: "flex",
        flexDirection: "column",
        gap: "15px",
      }}
    >
      <Box>
        <Box sx={{ display: "grid", gap: "15px" }}>
          <div className="flex width-100">
            <FormControl variant="outlined" className="width-100" size="small">
              <InputLabel>{t("LBL_DATA_CONN")}</InputLabel>
              <Select
                disabled={connectionLoading || tableLoading || metaLoading || top25Loading || sqlLoading || compareLoading}
                className={"width-100"}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 300,
                    },
                  },
                }}
                value={connection}
                label={t("LBL_DATA_CONN")}
                id="columnNameDropDown"
                onChange={(e) => {
                  setSchema("");
                  setSelectedTable('');
                  setIsShemaLoaded(false);
                  setConnection(e.target.value);
                  updateSchemaOptions([]);
                  updateTableRowData([]);
                  // disableAllLoading();
                }}
              >
                {connectOptions}
              </Select>
            </FormControl>
            <LightTooltip title="Launch Pre Defined Connection Screen">
              <Button
                variant="outlined"
                size="small"
                disableElevation
                className="margin-left-4"
                sx={{
                  width: "90%",
                  padding: "4px 8px",
                }}
                onClick={loadDatabaseSchemaHandler}
                disabled={isSchemaLoaded || connectionLoading || !connection || connection === t('SELECT')}
              >
                {connectionLoading ? <CircularProgress size={"16px"} /> : isSchemaLoaded ? t('SUCCESFULLY_LOADED_SCHEMA') : t('LOAD_DATABASE_SCHEMA')}
              </Button>
            </LightTooltip>
          </div>
          <FormControl variant="outlined" className="width-100" size="small">
            <InputLabel>{t("SELECT_DATABASE_SCHEMA")}</InputLabel>
            <Select
              disabled={connectionLoading || tableLoading || metaLoading || top25Loading || sqlLoading || compareLoading || !connection || connection === t('SELECT')}
              className={"width-100"}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 300,
                  },
                },
              }}
              name={"COLUMN_NAME"}
              value={schema}
              labelId="columnNameDropDown"
              label={t("SELECT_DATABASE_SCHEMA")}
              id="columnNameDropDown"
              onChange={(e) => {
                setConnectionLoading(true);
                setSchema(e.target.value);
                setSelectedTable('');
                // disableAllLoading();
              }}
            >
              {schemaOptions}
            </Select>
          </FormControl>
          <FormControl variant="outlined" className="width-100" size="small">
            <InputLabel>{t("ENCODING")}</InputLabel>
            <Select
              disabled={connectionLoading || tableLoading || metaLoading || top25Loading || sqlLoading || compareLoading}
              className={"width-100"}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 300,
                  },
                },
              }}
              value={encoding}
              onChange={(e) => {
                setEncoding(e.target.value);
              }}
            >
              {encodingOptions}
            </Select>
          </FormControl>
          <div className="flex flex-wrap">
            <LabeledCheckbox
              disabled={connectionLoading || tableLoading || metaLoading || top25Loading || sqlLoading || compareLoading || !connection || connection === t('SELECT')}
              checked={prepend}
              handleCheck={(checked) => setPrepend(checked)} label={t("BTN_ADD_SCHEMA_NAME")}
            />
            <LabeledCheckbox
              disabled={connectionLoading || tableLoading || metaLoading || top25Loading || sqlLoading || compareLoading || !connection || connection === t('SELECT')}
              checked={sort}
              handleCheck={(checked) =>
                setSort(checked)}
              label={t("BTN_SORT_DB_COLUMNS")}
            />
          </div>
        </Box>
      </Box>
      <Box className={"height-100"} sx={{ opacity: (connectionLoading || tableLoading || metaLoading || top25Loading || sqlLoading || compareLoading) ? "0.7" : '1' }}>
        {(tableLoading || connectionLoading) ? <Loader /> : <CommonGrid
          getGridAPI={(api) => setGridAPI(api)}
          containerClasses={"database-navigator-left-grid ag-theme-alpine"}
          rowData={rowData}
          gridOptions={gridOptions}
          gridProps={{
            suppressRowClickSelection: connectionLoading || tableLoading || metaLoading || top25Loading || sqlLoading || compareLoading,
            rowSelection: "single",
            onRowDataUpdated: onRowDataUpdated,
          }}
        />}
      </Box>
    </Box>
  );
};

export default DatabaseNavigatorLeft;
